
import { Options, Vue } from "vue-class-component";
import DropZone from "@/components/DropZone.vue";
import Text from "@/components/Text.vue";

@Options({
  components: {
    DropZone,
    Text,
  },
})
export default class Home extends Vue {
  mounted() {
    let width;
    let height;

    if (window.screen.availWidth < 500 || window.screen.availHeight < 500) {
      if (window.screen.availWidth < window.screen.availHeight) {
        width = height = window.screen.availWidth;
      } else {
        height = width = window.screen.availHeight;
      }
      this.$store.commit("setDimensions", { width, height });
    }
  }
}
